<template>
<div class="chapter">
<div class="inner_page">
<p class="ch-noft">Also by Michele Clark McConnochie</p>
<p class="fmp">The Strange Sagas of Sabrina Summers Saga 1:<br/>The Uncooperative Flying Carpet</p>
<p class="ch-nof">And coming soon:</p>
<p class="fmp">The Strange Sagas of Sabrina Summers Saga 3:<br/>The Uncontrollable Slingshot</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm02.vue?2852981c